const state = {
  //选择的账号
  adCount: null,
  //选择的app
  checkedApp: {},
  planType: 2, //2新建的计划 1已有的计划（仅用于广告组数据没有保存时的数据联动，不作为接口参数）
  /*********************  接口数据  **********************/
  //分配规则
  split_rule: {
    // audience: "campaign",
    creative_category: "campaign",
    targeting: "campaign",
    budget_and_bid: "campaign",
    creative_groups: "campaign",
    title_group: "campaign",
  },
  //广告组
  draft_campaign: null,
  draft_adset: {
    //投放内容
    promote_object: null,
    //投放位置
    delivery_placement: {
      delivery_range: 'default', //投放范围
      scene_id: [1],             //投放资源位置
    },
    //定向包
    targeting: null,
    //人群包
    // audience: null,
    //预算与报价
    budget_and_bid: null,
    //广告计划名称
    name_rule: null,
    //落地页
    // sitepage: null,
  },
  //广告创意
  draft_ad: {
    //广告创意名称
    name_rule: '',
    //行动号召按钮文案
    action_bar_text: '',
    //监测链接
    clickUrl:'',
    //贴纸样式对象
    overlay_group: null,
    //创意组
    creative_groups: null,
    //创意基础设置
    // adCreativeBaseInfo: null,
    //标题组
    title_group: null,
    //创意分类
    creative_category: null
  },
  //落地页
  web_urls:[],
}

const actions = {

}


const mutations = {
  //设置账号数据
  setadCount_k(state, data) { state.adCount = data },  //用
  //设置app数据
  setcheckedApp_k(state, data) { state.checkedApp = data },   //用
  //转化的监测链接
  setclickUrl_k(state, data) {state.draft_ad.clickUrl = data},   //用

  //设置分配规则
  set_split_rule_k: (state, data) => { state.split_rule[data.key] = data.value }, //用
  set_allsplit_rule_k: (state, data) => { state.split_rule = data },  //用
  //设置广告组
  set_draft_campaign_k: (state, data) => { state.draft_campaign = data },
  set_plan_type_k: (state, data) => { state.planType = data },
  
  //设置基础设置-投放内容
  set_promote_object_k: (state, data) => { state.draft_adset.promote_object = data }, //用
  //设置基础设置-投放范围
  set_delivery_range_k: (state, data) => { state.draft_adset.delivery_placement.delivery_range = data }, //用
  //设置基础设置-投放位置
  set_scene_id_k: (state, data) => { state.draft_adset.delivery_placement.scene_id = data }, //用
  //设置定向包
  set_targeting_k: (state, data) => { state.draft_adset.targeting = data }, //用
  //设置人群包
  // set_audience_k: (state, data) => { state.draft_adset.audience = data },
  //设置预算和出价
  set_budget_and_bid_k: (state, data) => { state.draft_adset.budget_and_bid = data }, //用
  //设置基础设置-广告计划名称
  set_name_rule_k: (state, data) => { state.draft_adset.name_rule = data },  //用
  //设置落地页
  // set_sitepage_k: (state, data) => { state.draft_adset.sitepage = data },
  
  //广告创意-创意组
  set_create_name_rule_k: (state, data) => { state.draft_ad.name_rule = data },  //用
  set_action_bar_text_k: (state, data) => { state.draft_ad.action_bar_text = data },  //用
  set_overlay_group_k: (state, data) => { state.draft_ad.overlay_group = data },  //用

  set_creative_groups_k: (state, data) => { state.draft_ad.creative_groups = data },  //用
  set_creative_groupName_k: (state, data) => {  //修改创意组名称   //用
    let { name, id } = data;
    let curGroup = state.draft_ad.creative_groups.find(item => item.itemId === id);
    if (curGroup) {
      curGroup.group_name = name;
    }
  },
  //智能抽帧素材挖掘
  set_cover_mining_k: (state, data) => {  //用
    state.draft_ad.smart_cover = data.smart_cover;
    state.draft_ad.asset_mining = data.asset_mining;
  },  
  //广告创意-创意基础设置
  // set_adCreativeBaseInfo_k: (state, data) => {state.draft_ad.adCreativeBaseInfo = data},
  //广告创意-标题组
  set_title_group_k: (state, data) => {state.draft_ad.title_group = data},  //用
  //广告创意-创意分类
  set_creative_category_k: (state, data) => { state.draft_ad.creative_category = data },  //用
  //落地页
  set_web_url_k: (state, data) => {state.web_urls = data},  //用
}



export default {
  state,
  actions,
  mutations
}